<template>
  <div v-if="!!phaseData">
    <field-label label="Selecione a vacina" class="mt-4">
      <v-row>
        <v-col>
          <search-server-field
            :itemText="(item) => `${item.name} - ${item.commercialName}`"
            path="vaccine"
            v-model="vaccineSelection.vaccine"
            multiple
          ></search-server-field>
        </v-col>

        <v-col>
          <v-menu
            ref="pickStartDate"
            v-model="pickStartDate"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="dateInput ? $moment(dateInput).format('DD/MM/YYYY') : 'Data da dose'"
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              />
            </template>
            <v-date-picker
              v-model="dateInput"
              no-title
              @change="pickStartDate = false"
              locale="pt-br"
              :max="$moment().subtract(1, 'days').toISOString()"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-col>
        <div v-if="!!vaccineSelection.vaccine">
          <div v-for="vaccine in vaccineSelection.vaccine" :key="vaccine.id">
            <field-label class="mt-2" :label="`Anotações da dose ${vaccine.name} - ${vaccine.commercialName}`">
              <text-field class="flex-grow-1" :max-length="250" v-model="vaccine.notes" />
            </field-label>
          </div>
        </div>
        <v-btn
          color="primary"
          :disabled="!vaccineSelection.vaccine"
          @click="addVaccine(vaccineSelection.vaccine, dateInput)"
          >adicionar vacina <v-icon small>mdi-plus-circle-outline</v-icon></v-btn
        >
      </v-col>
    </field-label>

    <field-label
      label="Vacinas Selecionadas"
      class="text-h6"
      titleColorClass="grey--text text--darken-2"
      v-if="phaseData.vaccines.length > 0"
    >
      <div v-for="category in vaccineCategories" :key="category">
        <v-row class="mt-4">
          <field-label :label="category" titleColorClass="grey--text text--darken-2" />
          <v-btn small text color="primary" @click="clearAllInCategory(category)">Limpar Categoria</v-btn>
        </v-row>
        <div class="ma-4" v-for="vaccine in shownVaccines(category)" :key="vaccine">
          <div>
            <v-row>
              <field-label :label="vaccine" />
              <v-btn icon x-small class="ma-2" @click="openDialog(vaccine)" title="Editar anotações"
                ><v-icon>mdi-text-box-edit-outline</v-icon></v-btn
              >
            </v-row>
            <div
              v-for="(vaccineDetail, index) in vaccineDetails(vaccine)"
              :key="`${index + vaccineDetail.date}`"
              class="d-flex flex-column elevation-1 pa-2"
              style="cursor: pointer"
            >
              <v-col class="ma-2">
                <v-row>
                  {{ `${$util.toFormattedDate(vaccineDetail.date)}` }}
                  <v-btn icon x-small class="ma-1" @click="deleteDose(vaccine, vaccineDetail.date)"
                    ><v-icon>mdi-trash-can</v-icon></v-btn
                  >
                </v-row>
              </v-col>
              <span
                class="text-subtitle-2 grey--text text--darken-1 ml-4"
                style="white-space: pre-line"
                v-if="vaccineDetail.notes != ''"
              >
                <b class="black--text">Anotações:</b>
                <v-btn
                  x-small
                  text
                  color="primary"
                  class="text-caption"
                  @click="toggleNotes(vaccineDetail.date + vaccine)"
                  v-if="vaccineDetail.notes >= 180"
                  >{{ notesDisplay[vaccineDetail.date + vaccine] ? 'Esconder' : 'Mostrar tudo' }}</v-btn
                >
                <br />
                <span
                  v-if="notesDisplay[vaccineDetail.date + vaccine] || vaccineDetail.notes.length <= 180"
                  class="text-subtitle-2 grey--text text--darken-1 ml-4"
                >
                  {{ vaccineDetail.notes }}
                </span>
                <span v-else class="text-subtitle-2 grey--text text--darken-1 ml-4">
                  {{ vaccineDetail.notes.slice(0, 180) + '...' }}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </field-label>

    <vaccine-info-dialog ref="vaccineInfoDialog" />
  </div>
</template>

<script>
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'

import FieldLabel from '@/components/FieldLabel.vue'
import SearchServerField from '@/components/SearchServerField.vue'
import TextField from '@/components/TextField.vue'

import VaccineInfoDialog from '../../VaccineInfoDialog.vue'

export default {
  components: { FieldLabel, SearchServerField, TextField, VaccineInfoDialog },
  extends: BasePhase,
  data() {
    return {
      pickStartDate: false,
      dateInput: null,
      notesDisplay: {},
      vaccineSelection: {
        vaccine: null,
      },
    }
  },
  computed: {
    vaccineCategories() {
      const categories = new Set(this.phaseData.vaccines.map((vaccine) => vaccine?.name))
      return categories
    },
  },
  methods: {
    getDefaultData() {
      const data = { vaccines: [] }
      return data
    },

    addVaccine(selectedVaccine, date) {
      selectedVaccine = selectedVaccine.map((vaccine) => ({
        id: vaccine.id,
        name: vaccine.name,
        commercialName: vaccine.commercialName,
        date: date,
        notes: vaccine.notes ? vaccine.notes : '',
      }))

      if (selectedVaccine.length === 0) {
        return this.$root.error('Escolha uma vacina.')
      }
      if (!date) {
        return this.$root.error('Data da vacina é obrigatório.')
      }

      if (
        this.phaseData.vaccines.find((vaccine) =>
          selectedVaccine.find((v) => v.id === vaccine.id && vaccine.date === v.date),
        )
      ) {
        return this.$root.error(`A vacina ${vac.name} - ${vac.commercialName} já tem uma dose na data ${date}`)
      } else {
        this.phaseData.vaccines = this.phaseData.vaccines.concat(selectedVaccine)
      }
    },

    shownVaccines(category) {
      const vaccines = new Set(
        this.phaseData.vaccines
          .filter((vaccine) => vaccine.name === category)
          .map((vaccine) => vaccine?.commercialName),
      )
      return vaccines
    },
    vaccineDetails(vaccine) {
      const details = this.phaseData.vaccines
        .filter((vac) => vac.commercialName === vaccine)
        .map((vaccine) => ({
          date: vaccine.date,
          notes: vaccine.notes,
        }))
        .sort((vaccineA, vaccineB) => {
          let dateA = new Date(vaccineA.date)
          let dateB = new Date(vaccineB.date)
          return dateA - dateB
        })
      return details
    },

    toggleNotes(vaccine) {
      this.$set(this.notesDisplay, vaccine, !this.notesDisplay[vaccine])
    },

    isInCategory(vaccine, category) {
      return vaccine.match(category)
    },

    openDialog(vaccineToView) {
      const filteredVaccines = this.phaseData.vaccines.filter((vaccine) => vaccine.commercialName === vaccineToView)
      this.$refs.vaccineInfoDialog.openDialog(filteredVaccines)
    },

    async deleteNotes(vaccine) {
      if (
        await this.$root.confirm(
          `Isso apagará as anotações do dia ${this.$util.toFormattedDate(vaccine.date)}, continuar?`,
        )
      ) {
        const vaccineToEdit = this.phaseData.vaccines.find((v) => v === vaccine)
        vaccineToEdit.notes = ''
      }
    },

    async clearAllInCategory(category) {
      if (await this.$root.confirm(`Isso apagará TODAS as vacinas de ${category}, continuar?`)) {
        const vaccinesToRemove = this.phaseData.vaccines.filter((vaccine) => vaccine.name === category)
        vaccinesToRemove.forEach((vaccine) => {
          this.phaseData.vaccines.splice(
            this.phaseData.vaccines.findIndex((v) => v.id === vaccine.id),
            1,
          )
        })
      }
    },

    async deleteDose(vaccine, date) {
      if (await this.$root.confirm(`Isso apagará dose do dia ${this.$util.toFormattedDate(date)}, continuar?`)) {
        this.phaseData.vaccines.splice(
          this.phaseData.vaccines.findIndex((vac) => vac.commercialName === vaccine && vac.date === date),
          1,
        )
      }
    },
  },

  mounted() {
    this.getDefaultData()
  },
}
</script>

<style scoped></style>
